<template>
  <extraction-saisie :title="title" :file-name="fileName"></extraction-saisie>
</template>

<script>
  import ExtractionSaisie from './ExtractionSaisie';
  export default {
    name: "ExtractionSaisieRGPD",
    components: { ExtractionSaisie },
    data() {
      return {
        title: 'Extraction statistiques dossier par date (RGPD Compliant)',
        fileName: 'extraction_saisie_rgpd',
      }
    }
  }
</script>


